import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from '../../../../shared/shared.module';
import { DATA_SELECTOR_INJECTION_TOKEN } from '@aiwyn/shared';

export interface FileNameConfirmationDialogData {
  originalFileName: string;
  originalExtension: string;
}

@Component({
  selector: 'app-file-name-confirmation-dialog',
  templateUrl: './file-name-confirmation-dialog.component.html',
  styleUrls: ['./file-name-confirmation-dialog.component.scss'],
  standalone: true,
  imports: [SharedModule],
  providers: [
    {
      provide: DATA_SELECTOR_INJECTION_TOKEN,
      useValue: 'file-name-confirmation-dialog',
    },
  ],
})
export class FileNameConfirmationDialogComponent {
  public dataSelector = inject(DATA_SELECTOR_INJECTION_TOKEN);

  constructor(
    public dialogRef: MatDialogRef<FileNameConfirmationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: FileNameConfirmationDialogData,
  ) {}

  /**
   * Close the modal without confirming.
   */
  onCancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Confirm the file replacement.
   */
  onConfirm(): void {
    this.dialogRef.close(true);
  }
}